import Model from "./Model";

export default class Broadcaster extends Model {
  static type = "broadcasters";

  brandName!: string;
  iconUrl?: string;
  vod!: boolean;

  get name() {
    return this.brandName;
  }

  set name(value: string) {
    this.brandName = value;
  }

  get type(): string {
    return Broadcaster.type;
  }

  get logoUrls(): string[] {
    if (this.iconUrl) {
      return [this.iconUrl];
    } else return [];
  }
}
